// Minimal inline-SVG sparkline. No chart library needed.
export default function Sparkline({
    values = [],
    width = 320,
    height = 80,
    stroke = "#2D5D4E",
    fill = "rgba(45,93,78,0.08)",
    showDots = true,
    personalBest = null,
}) {
    if (!values.length) {
        return (
            <div
                style={{ width, height }}
                className="flex items-center justify-center text-sm text-[#819888] border border-dashed border-[#E5E7E2] rounded-lg"
            >
                No data yet
            </div>
        );
    }

    const min = Math.min(...values, 0);
    const max = Math.max(...values, 1);
    const range = max - min || 1;
    const stepX = values.length === 1 ? width / 2 : width / (values.length - 1);

    const toY = (v) => height - 6 - ((v - min) / range) * (height - 12);

    const points = values.map((v, i) => [i === 0 ? 0 : (values.length === 1 ? width / 2 : i * stepX), toY(v)]);
    const path = points.map(([x, y], i) => `${i === 0 ? "M" : "L"} ${x.toFixed(1)} ${y.toFixed(1)}`).join(" ");
    const areaPath = `${path} L ${points[points.length - 1][0].toFixed(1)} ${height} L ${points[0][0].toFixed(1)} ${height} Z`;
    const pbY = personalBest != null ? toY(personalBest) : null;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
            {pbY != null && (
                <line x1="0" y1={pbY} x2={width} y2={pbY} stroke="#D47A55" strokeWidth="1" strokeDasharray="3 3" opacity="0.55" />
            )}
            <path d={areaPath} fill={fill} />
            <path d={path} stroke={stroke} strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            {showDots && points.map(([x, y], i) => (
                <circle key={i} cx={x} cy={y} r={i === points.length - 1 ? 4 : 2.4} fill={i === points.length - 1 ? stroke : "#FAF9F6"} stroke={stroke} strokeWidth={i === points.length - 1 ? 0 : 1.5} />
            ))}
        </svg>
    );
}
